import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridRoutingModule } from './grid-routing.module';
import { GridComponent } from './grid.component';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import * as hljs from 'highlight.js';
import { HighlightJsModule, HIGHLIGHT_JS } from 'angular-highlight-js';
export function highlightJsFactory() {
  return hljs;
}
@NgModule({
  imports: [
    CommonModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    GridRoutingModule,
    HighlightJsModule.forRoot({
      provide: HIGHLIGHT_JS,
      useFactory: highlightJsFactory
    })
  ],
  declarations: [
  	GridComponent
  ]
})
export class GridModule { }



// WEBPACK FOOTER //
// ./src/app/view/grid/grid.module.ts